import axios from "axios"

import { Course } from "@/models/course.js"

export const getCourse = async ({ courseId }) => {
  const response = await axios.get(`/api/v3/courses/${courseId}`)

  return { ...response, course: new Course(response.course) }
}

export const getEnrolledCourses = async () => {
  const response = await axios.get("/api/v3/courses/enrolled")

  return { ...response, courses: response.courses.map((c) => new Course(c)) }
}

export const getCompletedCourses = async () => {
  const response = await axios.get("/api/v3/courses/completed")

  return { ...response, courses: response.courses.map((c) => new Course(c)) }
}

export const enroll = ({ courseId }) => axios.post(`/api/v2/courses/${courseId}/enroll`)

export const unenroll = ({ courseId }) => axios.post(`/api/v2/courses/${courseId}/unenroll`)

export const restart = ({ courseId }) => axios.post(`/api/v2/courses/${courseId}/restart`)

export const updateCurrentLesson = ({ courseId, lessonId }) =>
  axios.put(`/api/v2/courses/${courseId}/current_lesson`, {
    lesson_id: lessonId
  })

export const completedMembers = ({ id, page }) =>
  axios.get(`/api/v2/courses/${id}/users/completed`, {
    params: {
      page
    }
  })

export const inProgressMembers = ({ id, page }) =>
  axios.get(`/api/v2/courses/${id}/users/enrolled`, {
    params: {
      page
    }
  })
